import * as React from 'react';
import { Typography } from '@material-ui/core';
import CheckboxField from './CheckboxField';
import RadioButtonField from './RadioButtonField';
import ToggleField from './ToggleField';
import DropdownField from './DropdownField';
import TextFieldHOC from './TextFieldHOC';

const FieldTypeComponentMapping = {
  checkbox: CheckboxField,
  radiobutton: RadioButtonField,
  toggle: ToggleField,
  dropdown: DropdownField,
  text: TextFieldHOC(),
  number: TextFieldHOC({ type: 'number' }),
  date: TextFieldHOC({
    type: 'date',
    InputLabelProps: {
      shrink: true,
    },
  }),
};

class SubscriptionConfig extends React.PureComponent<any, any> {
  public getComponentForFieldType = (field: any) => {
    const { values, onChange } = this.props;
    const FieldComponent = FieldTypeComponentMapping[field.type];
    return (
      <FieldComponent
        key={field.field}
        field={field}
        value={values[field.field]}
        onChange={onChange}
      />
    );
  };

  public render() {
    const { fields } = this.props;

    if (!fields.length) {
      return null;
    }
    
    return (
      <div>
        <Typography variant="subheading">
          The following fields are required for subscribing to this asset.
        </Typography>
        <form style={{ display: 'flex', flexWrap: 'wrap' }}>
          {fields.map(this.getComponentForFieldType)}
        </form>
      </div>
    );
  }
}

export default SubscriptionConfig;



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/SubscriptionConfig.tsx